import React, { useEffect } from "react";
import { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserGuideAction,
  postNewsLetterAction,
} from "../../actions/userGuide";
import { backendUrl, USER_GUIDE_MODAL } from "../../constants";
import ContentLoader from "react-content-loader";
import { setGuideCloseAction } from "../../actions/auth";
import { useLocation } from "react-router";

export default function UserGuide({ guideOpen, guideClose }) {
  const dispatch = useDispatch();
  const [showSteps, setShowSteps] = useState(false);
  const location = useLocation();
  const { userGuide, userGuideFlag, identityType } = useSelector((state) => state.userGuide);
  const handleClose = () => {
    setShowSteps(false);
    guideClose();
    setCurrentStep(0);
    if (identityType !== USER_GUIDE_MODAL.DEFAULT) {
      dispatch(setGuideCloseAction(location.pathname));
    }
  };

  const { user } = useSelector((state) => state.user);
  useEffect(() => {
    if (guideOpen) {
      const callUserGuideAction = () => {
        dispatch(getUserGuideAction());
      };
      callUserGuideAction();
    }
  }, [dispatch, guideOpen]);
  const [currentStep, setCurrentStep] = useState(0);
  const [newsLetter, setNewsLetter] = useState(false);

  const nextStep = () => {
    if (currentStep < showSteps?.innerSteps?.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleNewsLetter = (event) => {
    setNewsLetter(true);
    if (event.target.checked) {
      dispatch(postNewsLetterAction());
    }
  };

  const handleBack = () => {
    setShowSteps(false);
    setCurrentStep(0);
  };

  const [currentSlide, setCurrentSlide] = useState(0);

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? userGuide.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev === userGuide.length - 1 ? 0 : prev + 1));
  };

  return (
    <>
      <Modal className="guide-modal" show={guideOpen} onHide={handleClose}>
        <div className="guideHeader">
          <p>
            {identityType === USER_GUIDE_MODAL.DEFAULT ?
              <>
                {!showSteps
                  ? `Welcome back, ${user && user?.first_name
                    ? user?.first_name + " " + user.last_name
                    : ""
                  }`
                  : `Step ${showSteps.innerSteps[currentStep].step}`}
              </>
              :
              <>
                {currentSlide === 0 ?
                  `Welcome back, ${user && user?.first_name
                    ? user?.first_name + " " + user.last_name
                    : ""
                  }`
                  :
                  `Step ${currentSlide}`
                }
              </>
            }
          </p>
          <i onClick={handleClose} className="fa-solid fa-xmark"></i>
        </div>
        <div className="modal-body">
          {identityType === USER_GUIDE_MODAL.DEFAULT &&
            <div className="bodyHeader">
              {showSteps ? (
                <span onClick={handleBack}>
                  <i className="fa-solid fa-arrow-left"></i> Back to user guide
                </span>
              ) : (
                <p>Since you left, we have new updates for you.</p>
              )}
            </div>
          }
          <div className={`${identityType === USER_GUIDE_MODAL.DEFAULT ? "guideBody" : ""} customScrollBar`}>
            {identityType === USER_GUIDE_MODAL.DEFAULT ?
              <>
                {showSteps ? (
                  <div
                    className={`${showSteps ? "stepsRow" : ""} guideContent row`}
                  >
                    {showSteps.innerSteps[currentStep].img && (
                      <div className="imgHolder col-md-6">
                        <img src={`${backendUrl + showSteps.innerSteps[currentStep].img}`}
                          alt={showSteps.innerSteps[currentStep].img}
                        />
                      </div>
                    )}
                    <div className={`stepContentHolder col-md-${showSteps.innerSteps[currentStep].img ? 6 : 12}`}>
                      <h5>{showSteps.innerSteps[currentStep].label}</h5>
                      <div
                        className="stepDesc"
                        dangerouslySetInnerHTML={{
                          __html: showSteps.innerSteps[currentStep].desc,
                        }}
                      ></div>
                      {showSteps.innerSteps[currentStep]?.tip &&
                        <div className="tipHolder">Tip: {showSteps.innerSteps[currentStep]?.tip}</div>
                      }

                      <div className="slider-controls-inner">
                        <div className="dots">
                          {showSteps.innerSteps.map((_, index) => (
                            <span
                              key={index}
                              className={`dot ${index === currentStep ? "active" : ""}`}
                              onClick={() => setCurrentSlide(index)}
                            ></span>
                          ))}
                        </div>
                        <div className="imageHolderGuide">
                          <div onClick={prevStep} className={`${currentStep === 0 ? "userGuideimageDisable" : ""} userGuideimageHolder`}>
                            <img src="/assets/img/arrow-prev-circle.svg" alt="" />
                          </div>
                          <div onClick={nextStep} className={`${currentStep === showSteps?.innerSteps?.length - 1 ? "userGuideimageDisable" : ""} userGuideimageHolder`}>
                            <img src="/assets/img/arrow-next-circle.svg" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    {!userGuideFlag ? (
                      userGuide?.length > 0 ? (
                        userGuide?.map((item, index) => (
                          <div key={index} className="guideContent row">
                            {item.img && (
                              <div className="imgHolder col-6">
                                <img
                                  src={`${backendUrl + item.img}`}
                                  alt={item.img}
                                />
                              </div>
                            )}
                            <div className={`contentHolder col-6`}>
                              <h5>{item.label}</h5>
                              <div
                                className="desc"
                                dangerouslySetInnerHTML={{
                                  __html: item.desc,
                                }}
                              ></div>
                              {item?.innerSteps?.length > 0 && (
                                <button
                                  onClick={() =>
                                    item?.isExternalUrl
                                      ? window.open(item.url)
                                      : setShowSteps(item)
                                  }
                                  className="btn btn-sm  mb-4 mt-3 contactus-modal-button articalBtn"
                                >
                                  {item?.isExternalUrl ? "See article" : "View steps"}
                                </button>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="m-0">No user guide available!</p>
                      )
                    ) : (
                      [1, 2].map((index) => (
                        <div key={index} className="pt-4 pb-2 skeltonSectionGuide">
                          <span>
                            <ContentLoader width={"100%"} height={150}>
                              <rect
                                x="0"
                                y="0"
                                rx="5"
                                ry="5"
                                width="100%"
                                height="150"
                              />
                            </ContentLoader>
                          </span>
                          <span>
                            <ContentLoader width={"100%"} height={150}>
                              <rect
                                x="0"
                                y="0"
                                rx="5"
                                ry="5"
                                width="100%"
                                height="40"
                              />
                              <rect
                                x="0"
                                y="60"
                                rx="5"
                                ry="5"
                                width="100%"
                                height="40"
                              />
                              <rect
                                x="0"
                                y="120"
                                rx="5"
                                ry="5"
                                width="30%"
                                height="40"
                              />
                            </ContentLoader>
                          </span>
                        </div>
                      ))
                    )}
                  </>
                )}
              </>
              :
              <>
                {!userGuideFlag ?
                  <div div className="slider-container">
                    <div className="slider-wrapper" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                      {userGuide.map((slide, index) => (
                        <div className="slider-slide" key={index}>
                          <div className="sliderImgHolder">
                            <img src={backendUrl + slide.img} alt={slide.label} />
                          </div>
                          <div className="sliderContentHolder">
                            <h4 className="userGuideTitle">{slide.label}</h4>
                            <div className="userGuideDesc" dangerouslySetInnerHTML={{ __html: slide.desc }} />
                            {slide?.tip &&
                              <div className="userGuideTipHolder">Tip: {slide.tip}</div>
                            }
                          </div>
                        </div>
                      ))}
                    </div>

                    <div className="slider-controls">
                      <div className="dots">
                        {userGuide.map((_, index) => (
                          <span
                            key={index}
                            className={`dot ${index === currentSlide ? "active" : ""}`}
                            onClick={() => setCurrentSlide(index)}
                          ></span>
                        ))}
                      </div>
                      <div className="imageHolderGuide">
                        <div onClick={goToPrev} className="userGuideimageHolder">
                          <img src="/assets/img/arrow-prev-circle.svg" alt="" />
                        </div>
                        <div onClick={goToNext} className="userGuideimageHolder">
                          <img src="/assets/img/arrow-next-circle.svg" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                  :
                  [1].map((index) => (
                    <div key={index} className="pt-4 pb-2 skeltonSectionGuide">
                      <span>
                        <ContentLoader width={"100%"} height={150}>
                          <rect
                            x="0"
                            y="0"
                            rx="5"
                            ry="5"
                            width="100%"
                            height="150"
                          />
                        </ContentLoader>
                      </span>
                      <span>
                        <ContentLoader width={"100%"} height={150}>
                          <rect
                            x="0"
                            y="0"
                            rx="5"
                            ry="5"
                            width="100%"
                            height="40"
                          />
                          <rect
                            x="0"
                            y="60"
                            rx="5"
                            ry="5"
                            width="100%"
                            height="40"
                          />
                          <rect
                            x="0"
                            y="120"
                            rx="5"
                            ry="5"
                            width="30%"
                            height="40"
                          />
                        </ContentLoader>
                      </span>
                    </div>
                  ))
                }
              </>
            }



          </div>
          <div className="bodyFooter form-check">
            <div className="inputHolderGuide">
              <input
                maxLength={50}
                autoComplete="nope"
                className="form-check-input m-0"
                onChange={handleNewsLetter}
                type="checkbox"
                id="newsletter"
                checked={newsLetter}
                disabled={newsLetter}
              />
              <label htmlFor="newsletter">
                I want feature updates sent to my email
              </label>
            </div>
            {/* <button className="userGuide border-0">submit</button> */}
          </div>
        </div>
      </Modal >
    </>
  );
}
